import GuidanceRegistry from '../guidance-registry.js';
import EnrollmentValidationErrors from "../../action-items/types/EnrollmentValidationErrors";

GuidanceRegistry.register({
    type: "action-item-ewf-setup-online-enrollments",
    prompt: "Please download and update your online enrollment census with all eligible participants’ information. Once completed, please upload your census. Your participants may begin making their elections on the open enrollment start date.",
    briefDescription: 'Online Enrollments',
    actions: [
        {
            text: "Download Online Enrollment Census",
            loadNextGuidance: false,
            click: (guidanceItem) => {romeApi.download(`employer/onlineenrollment/${guidanceItem.employerId}/enrollment/download`);    }
        },
        { 
            fileSelector: true,
            text: "Upload Online Enrollment Census",
            loadNextGuidance: false,
            fileSelectedText: "Validating census data",
            onFileSelected: async (component, guidanceItem, file) => {
                if(!file) return;
        
                let formData = new FormData();
                formData.append('file', file);
            
                let uploadErrors = await romeApi.upload(`employer/onlineenrollment/${guidanceItem.employerId}/enrollment/upload/${guidanceItem.actionItemId}`, formData);

                if(uploadErrors && uploadErrors.length > 0) 
                {
                    await modalService.show("enrollmentValidationErrors", EnrollmentValidationErrors, { 
                        lines: uploadErrors,
                        title: "Enrollment Spreadsheet Errors",
                        errorStyle: true,
                        employerId: guidanceItem.employerId
                    });
                    document.getElementById("guidanceFileUpload").value = null;
                    return false;
                } 
                else 
                {
                    let result = await romeApi.post(`/actionitem/v-2/${guidanceItem.actionItemId}/validate`);

                    if(!result.ok) 
                    {
                        let validationErrors = [];
                        validationErrors.push({error: result.message});
                        let dto = {errors: validationErrors};

                        await modalService.info(result.message, {
                            buttonsCustom: [{
                                name: "Download Errors",
                                onClick: async () => await romeApi.postDownload(`actionitem/v-2/${guidanceItem.actionItemId}/errors/download`, null, dto)
                            }]
                        });

                        document.getElementById("guidanceFileUpload").value = null;
                    } 
                    else 
                    {
                        await romeApi.post(`actionitem/v-2/${guidanceItem.actionItemId}/complete`);
                        await component.$store.dispatch("actionItems/refresh");
                        await component.refresh();
                    }
                }
            },
            click: async (component, guidanceItem) => {
                    document.getElementById("guidanceFileUpload").click();
            }
        },
    ]});



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-upload-census.js